import { storageKeys } from "./storageKeys";

export const getConfig = () => {
  if (typeof window !== "undefined") {
    const config = JSON.parse(localStorage.getItem(storageKeys.remoteConfig));
    return { ...config, initialized: true };
  }
  return { initialized: false };
};

export const isUserInSegment = (experiment, segment) => {
  const config = getConfig();

  if (config) {
    if (!config[experiment]) {
      return false;
    }
    return config[experiment] === segment;
  }
};

export const experiments = () => {
  const config = getConfig();

  Object?.keys(config)?.forEach((key) => {
    if (!config[key]) {
      delete config[key];
    }
  });

  return {
    experimentsLoaded: config.initialized,
    onboardingPriceExperiment:
      config.experiment_web_pricing_australia_799vs599 && {
        AU: config.experiment_web_pricing_australia_799vs599,
      },
  };
};
